// extracted by mini-css-extract-plugin
export var explainable = "_fb-a";
export var printerCard = "_fb-1";
export var printerCardConfigured = "_fb-2";
export var printerCardError = "_fb-3";
export var printerCardsContainer = "_fb-0";
export var printerIcon = "_fb-8";
export var printerIconConfigured = "_fb-5";
export var printerIconContainer = "_fb-4";
export var printerIconError = "_fb-6";
export var printerIconUnconfigured = "_fb-7";
export var workstationsTableCard = "_fb-9";